
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/api-triggered-sends",
      function () {
        return require("private-next-pages/native-delivery/api-triggered-sends.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/api-triggered-sends"])
      });
    }
  